export { default } from "./Lightbox.jsx"
